import { useMemo } from "react";
import { useOutgoingMailboxQuery } from "../../api/queries/organizationQueries";
import { useAuth } from "../../hooks/useAuth";
import type { ReplySelfContext } from "../../utils/replyRecipients";

export function useMailboxContext(): ReplySelfContext {
  const { email: loginEmail } = useAuth();
  const { data: outgoingMailbox } = useOutgoingMailboxQuery();

  return useMemo(
    () => ({
      mailboxEmail:
        outgoingMailbox?.uses_official_email &&
        outgoingMailbox.official_outgoing_email
          ? outgoingMailbox.official_outgoing_email
          : outgoingMailbox?.mailbox_email ?? null,
      loginEmail: loginEmail ?? null,
    }),
    [outgoingMailbox, loginEmail],
  );
}
